<template>
  <div :class="emphasis ? 'font-semibold' : ''">
    <div class="flex items-center justify-between">
      <dt
        :class="[
          'text-sm leading-loose',
          emphasis
            ? 'text-background-fg'
            : 'text-background-fg/70',
        ]"
      >
        {{ label }}
      </dt>
      <dd class="text-base">
        {{ formattedAmount }}
      </dd>
    </div>
    <p
      v-if="count != null"
      class="text-xs text-background-fg/50"
    >
      {{ count }}
      {{ count === 1 ? "transaction" : "transactions" }}
    </p>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  label: string
  count: number | null
  amount: number | null
  emphasis?: boolean
}>()

const { formatToMerchantCurrencyString } = useCurrency()

const formattedAmount = computed(() =>
  props.amount == null
    ? "—"
    : formatToMerchantCurrencyString(props.amount)
)
</script>
